/**
 * Partnero `customers / signup` event (GROWTH-6929).
 *
 * The backend flag `need_to_call_partnero` is 1 for an account whose signup has
 * not been reported to Partnero yet. The dashboard sends the event once, then
 * tells the backend to clear the flag.
 */

export const shouldSendPartneroSignup = profile => Number(profile?.need_to_call_partnero) === 1;

// A flagged account with an email: the only kind worth loading the Partnero script for.
export const hasPartneroSignupToSend = profile => shouldSendPartneroSignup(profile) && Boolean(profile.email);

export const getPartneroSignupData = (profile = {}) => ({
  // Partnero customers are keyed by email (not the aMember user_id).
  key: profile.email,
  name: [profile.name_f, profile.name_l]
    .map(part => String(part || "").trim())
    .filter(Boolean)
    .join(" "),
  email: profile.email
});

/**
 * Queues the signup event on the Partnero universal script (`window.po`,
 * set up by helpers/partneroLoader.js). Returns true when the event was queued.
 */
export const sendPartneroSignup = (profile, po = window.po) => {
  if (!hasPartneroSignupToSend(profile) || typeof po !== "function") {
    return false;
  }

  try {
    po("customers", "signup", { data: getPartneroSignupData(profile) });
  } catch {
    // A third-party marketing script must never break the profile load.
    return false;
  }

  return true;
};
